import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  width = "12",
  height = "14",
  fill = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 14"
    fill={fill}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.55922 1.35901C2.08413 1.35901 1.69901 1.74168 1.69901 2.21371V11.7864C1.69901 12.2584 2.08413 12.641 2.55922 12.641H9.44095C9.91602 12.641 10.3011 12.2584 10.3011 11.7864V5.0937C10.3011 4.87119 10.2138 4.65745 10.0577 4.49791L7.23968 1.61792C7.07768 1.4524 6.85522 1.35901 6.62288 1.35901H2.55922ZM0.666748 2.21371C0.666748 1.17523 1.51403 0.333374 2.55922 0.333374H6.62288C7.13408 0.333374 7.62348 0.538821 7.97982 0.902967L10.7978 3.78295C11.1413 4.13394 11.3334 4.60417 11.3334 5.0937V11.7864C11.3334 12.8248 10.4861 13.6667 9.44095 13.6667H2.55922C1.51403 13.6667 0.666748 12.8248 0.666748 11.7864V2.21371Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.41943 9.05125C3.41943 9.33452 3.65051 9.56412 3.93557 9.56412H8.06461C8.34961 9.56412 8.58075 9.33452 8.58075 9.05125C8.58075 8.76805 8.34961 8.53845 8.06461 8.53845H3.93557C3.65051 8.53845 3.41943 8.76805 3.41943 9.05125Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.41943 6.31633C3.41943 6.59953 3.65051 6.82913 3.93557 6.82913H6.00008C6.28515 6.82913 6.51621 6.59953 6.51621 6.31633C6.51621 6.03307 6.28515 5.80347 6.00008 5.80347H3.93557C3.65051 5.80347 3.41943 6.03307 3.41943 6.31633Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
